import { createSelector } from '@ngrx/store';
import { IAppState } from '../../common/interfaces/app-state.interface';
import { IAccountManagerContactStore } from '../interfaces/account-manager-contact-store.interface';

export const selectAccountManagerContactStore = (state: IAppState) =>
  state.accountManagerContact;

export const selectAllAccountManagerContact = createSelector(
  selectAccountManagerContactStore,
  (accountManagerContactStore: IAccountManagerContactStore) => ({
    firstName: accountManagerContactStore.firstName,
    lastName: accountManagerContactStore.lastName,
    email: accountManagerContactStore.email,
    phoneNumber: accountManagerContactStore.phoneNumber,
  })
);
